// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"173":"02ca9bba","327":"6e52b785","443":"a046190e","531":"7e7c0952","614":"7d5d9bed","674":"57d3cb85","846":"5a9db436","857":"f2936de6","948":"7114e63d"}[chunkId] + ".js";
};